import React, { useContext } from "react";
import { Grid, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Card from "components/ui/Card";
import { encodeStr } from "utils/encodeDecodeStr";
import SortContext from "context/SortContext";

const SubStockDesign = ({ subcategory }) => {
  const navigate = useNavigate();
  const { category } = useParams();
  const location = useLocation();
  const { search } = useContext(SortContext);

  const handleNavigate = (subcategory) => {
    const extractedName = location.state.name[0].split(" - ")[0];
    const state = {
      ...location.state,
      name: [`${extractedName}`, `${subcategory.subCategory}`],
      subStockSearch: search !== "" ? search : "",
    };
    navigate(`/Stock/${category}/${encodeStr(subcategory.subCategory)}`, { state });
  };

  return (
    <Card style={{ minWidth: 275, maxWidth: "317px", height: 62, borderRadius: "5px" }} onClick={() => handleNavigate(subcategory)}>
      <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
        {subcategory.subCategory}
      </Typography>
      <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
        {subcategory.count}
      </Typography>
    </Card>
  );
};

export default SubStockDesign;
